export class TirContour {
  format: string;
  coordonnees: string;
  typePolygone:number;

}
